export default {
  // DirectTeachingActivityView
  editActivity: 'Editar Actividad Presencial',
  deleteActivity: 'Eliminar Actividad Presencial',
  deleteActivityConfirmation: '¿Está seguro de que desea eliminar la Actividad Presencial?',
  activityDeleted: 'Actividad Presencial eliminada.',

  // DirectTeachingActivityForm
  activityCreated: 'Actividad Presencial creada.',
  activityUpdated: 'Actividad Presencial actualizada.',
}
